module.exports = __webpack_public_path__ + "img/avatar1.ea2d9ecb.png";